import { __assign } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common';
export var TrackComponent = function (_a) {
    var source = _a.source, target = _a.target, getTrackProps = _a.getTrackProps, disabled = _a.disabled;
    var left = source.percent + "%";
    var width = target.percent - source.percent + "%";
    var visibleTrackClassNames = namespacedClassnames('track-visible', { disabled: disabled });
    var hotspotTrackClassNames = namespacedClassnames('track-hotspot', { disabled: disabled });
    var styles = {
        left: left,
        width: width,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: styles, className: visibleTrackClassNames }),
        React.createElement("div", __assign({ style: styles, className: hotspotTrackClassNames }, getTrackProps()))));
};
var HandleCounter = function (_a) {
    var percent = _a.percent, value = _a.value, _b = _a.tooltipRenderer, tooltipRenderer = _b === void 0 ? function (_a) {
        var v = _a.value;
        return v.toString();
    } : _b;
    var closeLeft = function () { return (percent < 10); };
    var closeRight = function () { return (percent > 90); };
    var classNames = namespacedClassnames('handle-counter', { 'close-left': closeLeft(), 'close-right': closeRight() });
    return (React.createElement("div", { className: classNames, style: { left: percent + "%" }, role: 'label' }, tooltipRenderer({ value: value, percent: percent })));
};
export var HandleComponent = function (_a) {
    var _b = _a.domain, min = _b[0], max = _b[1], _c = _a.handle, id = _c.id, value = _c.value, percent = _c.percent, getHandleProps = _a.getHandleProps, disabled = _a.disabled, tooltipRenderer = _a.tooltipRenderer;
    var style = {
        left: percent + "%",
    };
    var visibleClassNames = namespacedClassnames('handle', 'visible', { disabled: disabled });
    var hotspotClassNames = namespacedClassnames('handle', 'hotspot', { disabled: disabled });
    return (React.createElement("div", { className: 'slider-handle' },
        React.createElement("div", { role: 'slider', "aria-valuemin": min, "aria-valuemax": max, "aria-valuenow": value, style: style, className: visibleClassNames }),
        React.createElement("button", __assign({ style: style, className: hotspotClassNames }, getHandleProps(id))),
        React.createElement(HandleCounter, { percent: percent, value: value, tooltipRenderer: tooltipRenderer })));
};
export var RailComponent = function (_a) {
    var getRailProps = _a.getRailProps, disabled = _a.disabled;
    var visibleClassNames = namespacedClassnames('slider-rail', 'visible', { disabled: disabled });
    var hotspotClassNames = namespacedClassnames('slider-rail', 'hotspot', { disabled: disabled });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: visibleClassNames }),
        React.createElement("div", __assign({ className: hotspotClassNames }, getRailProps()))));
};
//# sourceMappingURL=components.js.map